<template>
  <div class="breadcrumb">
    <ul>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        @click="routeTo(idx)"
        :class="{'linked': !!breadcrumb.link}"
        :style="{ color: textColor ? textColor : 'black' }"
      >{{ breadcrumb.name }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    textColor: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      breadcrumbList: []
    };
  },
  mounted() {
    this.updateList();
  },
  watch: {
    $route() {
      this.updateList();
    }
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link)
        this.$router.push(this.breadcrumbList[pRouteTo].link);
    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    }
  }
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
  padding-left: 0;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: black;
  font-weight: bold;
  font-size: 1.1em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.1em;
  margin: 0 0.5em;
  /* color: grey; */
  color: black;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.1em;
  font-weight: normal;
  /* color: grey; */
  color: black;
}
</style>